<template>
    <div>
        <h1 class="title">Datos Personales</h1>

        <form>
            <b-field grouped>
                <b-field label="Nombres" expanded>
                    <b-input v-model="info.firstName"></b-input>
                </b-field>
                <b-field label="Apellidos" expanded>
                    <b-input v-model="info.lastName"></b-input>
                </b-field>
            </b-field>

            <b-field>
                <b-field>
                    <b-field label="e-mail">
                        <b-input v-model="info.email"></b-input>
                    </b-field>
                </b-field>
            </b-field>

            <a class="button is-primary" v-on:click="onSaveUserDataSelected">Guardar</a>
        </form>
    </div>
</template>

<script>
    export default {
        name: 'account-information',

        data() {
            return {
                info: {
                    firstName: '',
                    lastName: '',
                    email: ''
                }
            }
        },

        components: {

        },

        computed: {
            customer() {
                return this.$store.state.customer.customer;
            }
        },

        mounted() {
            this.info.firstName = this.customer.firstName;
            this.info.lastName = this.customer.lastName;
            this.info.email = this.customer.email;
        },

        methods: {
            onSaveUserDataSelected() {
                return this.$store.dispatch('customer/patch', this.info).then((/*response*/) => {

                }).catch((/*error*/) => {

                });
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>